import Banner from "../../components/banner/Banner"
import TargetsList from "../../components/targets/Targets"
import "./targets.scss"

const Targets = () => {
  return (
    <div className="targets">
        <Banner title="Targets"/>
        <TargetsList/>
    </div>
  )
}

export default Targets